import { css } from '@emotion/react'
import ColorJS from 'colorjs.io'
import React from 'react'
import { TypeOptions } from 'react-toastify'
import { Color, DeprecatedGemColors } from '@opallabs/gem'
import { colors, WithStyleOverrides } from '../../gem'

type IconProps = WithStyleOverrides & {
  backgroundColor: string
  color: string
  glyph: string
  size: number
}

export const useIconProps = (type?: TypeOptions): IconProps | null =>
  React.useMemo(() => {
    // Unsupported types from 'react-toastify' don't get an icon
    if (type === undefined || type === 'default') {
      return null
    }

    const makeBackground = (base: string): string => {
      return new ColorJS(base)
        .set({ 'hsl.l': (c) => c * 0.75 }) // lighen by 75%
        .toString({ format: 'p3' })
    }

    return {
      success: {
        backgroundColor: makeBackground(DeprecatedGemColors.GL100),
        color: Color.light.Surface.N000,
        glyph: 'gem-check',
        size: 12.5,
        styleOverrides: css({ position: 'relative' }),
      },
      warning: {
        backgroundColor: makeBackground(colors.light.secondary.yellow100),
        color: colors.light.secondary.yellow100,
        glyph: 'gem-warning-filled',
        size: 20,
      },
      info: {
        backgroundColor: makeBackground(DeprecatedGemColors.BL200),
        color: Color.light.Text.Accent,
        glyph: 'gem-info-circle-filled',
        size: 20,
      },
      error: {
        backgroundColor: makeBackground(DeprecatedGemColors.RL100),
        color: Color.light.Text.Warning,
        glyph: 'gem-close-circle-filled',
        size: 20,
      },
    }[type]
  }, [type])
